import { render, staticRenderFns } from "./Greetings.vue?vue&type=template&id=3dc3214e&scoped=true"
import script from "./Greetings.vue?vue&type=script&lang=js"
export * from "./Greetings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc3214e",
  null
  
)

export default component.exports